import "./NotificationAlertToggles.scss";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import FlowCheckbox from "../FlowCheckbox/FlowCheckbox";
import {
  isSoundEnabled,
  setSoundEnabled,
  isVibrationEnabled,
  setVibrationEnabled,
  isVibrationSupported,
  playNotificationSound,
} from "../../utils/notificationAlerts";

// Sound/vibration for new notifications while the app is open (this device)
function NotificationAlertToggles() {
  const { t } = useTranslation();
  const [sound, setSound] = useState(isSoundEnabled);
  const [vibration, setVibration] = useState(isVibrationEnabled);

  const handleSoundChange = (enabled) => {
    setSoundEnabled(enabled);
    setSound(enabled);
    // Let the user hear what they turned on
    if (enabled) playNotificationSound();
  };

  const handleVibrationChange = (enabled) => {
    setVibrationEnabled(enabled);
    setVibration(enabled);
  };

  return (
    <div className="notification-alert-toggles">
      <FlowCheckbox
        checked={sound}
        onChange={handleSoundChange}
        label={t("notifications.alerts.sound")}
      />
      {isVibrationSupported() && (
        <FlowCheckbox
          checked={vibration}
          onChange={handleVibrationChange}
          label={t("notifications.alerts.vibration")}
        />
      )}
    </div>
  );
}

export default NotificationAlertToggles;
